<template>
  <div class="vx-col w-full mb-base m-auto">
    <vx-card title="Manage Users">
      <div class="text-right add-country" v-if="!userAddEdit">
        <vs-button class="mt-4 m-auto" color="#0057FF" @click.prevent="userAddEdit = true">Add User</vs-button>
      </div>
      <form class="w-full" v-if="userAddEdit" autocomplete="off">
        <div class="vx-row mb-2">
          <h3 class="ml-5 mb-5">{{ userIndex ? 'Edit' : 'Add' }} User</h3>
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col md:w-1/3 form-group w-full">
            <vs-input
              type="email"
              class="w-full"
              label="Email"
              v-validate="'required|email'"
              name="email"
              v-model="email"
              autocomplete="off"
              :disabled="userIndex"
            />
            <span class="text-danger text-sm">{{ errors.first('email') }}</span>
          </div>
          <div class="vx-col md:w-1/3 form-group w-full">
            <vs-input
              class="w-full"
              label="Password"
              v-validate="!userIndex ? 'required|verify_password|min:8|max:20' : ''"
              name="password"
              v-model="password"
              autocomplete="off"
              type="password"
              :disabled="userIndex"
              ref="passwordRef"
            />
            <span class="text-danger text-sm">{{ errors.first('password') }}</span>
          </div>
          <div class="vx-col md:w-1/3 form-group w-full" v-if="!userIndex">
            <vs-input
              class="w-full"
              label="Confirm Password"
              type="password"
              v-validate="'required|confirmed:passwordRef'"
              name="password_confirmation"
              v-model="confirm_password"
            />
            <span class="text-danger text-sm">{{ errors.first('password_confirmation') }}</span>
          </div>
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col md:w-1/3 form-group w-full">
            <vs-input
              type="text"
              class="w-full"
              label="First Name"
              v-validate="'required|alpha_spaces|max:25'"
              name="first_name"
              v-model="firstName"
              autocomplete="off"
            />
            <span class="text-danger text-sm">{{ errors.first('first_name') }}</span>
          </div>
          <div class="vx-col md:w-1/3 form-group w-full">
            <vs-input
              type="text"
              class="w-full"
              label="Last Name"
              v-validate="'required|alpha_spaces|max:25'"
              name="last_name"
              v-model="lastName"
              autocomplete="off"
            />
            <span class="text-danger text-sm">{{ errors.first('last_name') }}</span>
          </div>
          <!-- <div class="vx-col md:w-1/3 form-group w-full">
            <vs-select
              autocomplete
              class="w-full"
              v-validate="'required'"
              label="User Role"
              name="role"
              v-model="roleIndex"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item,index) in role_list"
              />
            </vs-select>
            <span class="text-danger text-sm">{{ errors.first('role') }}</span>
          </div>-->
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col md:w-1/2">
            <label>Profile</label>
            <div class v-if="!profile_image">
              <vue-image-upload
                field="img"
                @crop-success="cropSuccess"
                v-model="show_image_popup"
                name="profile_image"
                :width="100"
                :height="100"
                lang-type="en"
                img-format="png"
                :no-rotate="false"
                :no-circle="true"
                :no-square="false"
              ></vue-image-upload>
              <vs-button
                color="primary"
                @click.prevent="show_image_popup = !show_image_popup"
                id="upload-profile-button"
              >Upload Profile</vs-button>
              <span class="text-danger text-sm">{{ errors.first('profile_image') }}</span>
            </div>
            <div class="vx-col md:w-1/2" v-else>
              <div class="img-upload" v-if="profile_image">
                <img
                  :src="profile_image"
                  class="mr-1"
                  style="width: 100px; max-height: 100px; float:left;"
                />
                <vs-button
                  color="primary"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-x"
                  @click.prevent="removeProfile()"
                ></vs-button>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col w-full">
            <vs-button
              class="mt-1 m-auto"
              color="#0057FF"
              @click.prevent="addUpdateUser()"
              :disabled="button_loading"
              id="user-addupdate"
            >{{ userIndex ? 'Save' : 'Add' }}</vs-button>
            <vs-button
              class="mt-1 ml-4 m-auto"
              color="primary"
              @click.prevent="cancelAddEdit()"
            >Cancel</vs-button>
          </div>
        </div>
      </form>
      <div class="mt-5 mb-5">
        <vs-table :data="users" pagination max-items="15">
          <template slot="thead">
            <vs-th sort-key="firstname">First Name</vs-th>
            <vs-th sort-key="lastname">Last Name</vs-th>
            <vs-th sort-key="email">Email</vs-th>
            <vs-th>Role</vs-th>
            <vs-th>Action</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>{{ data[indextr].firstname | capitalize }}</vs-td>
              <vs-td>{{ data[indextr].lastname | capitalize }}</vs-td>
              <vs-td>{{ data[indextr].email }}</vs-td>
              <vs-td>{{ data[indextr].roles === 'SA' ? 'Super Admin' : 'Admin' }}</vs-td>
              <vs-td>
                <vs-button
                  color="#F4B400"
                  type="filled"
                  class="mr-2 mb-2 float-left"
                  icon-pack="feather"
                  icon="icon-edit-2"
                  size="small"
                  title="Edit User"
                  @click.stop="editUser(data[indextr])"
                ></vs-button>
                <vs-button
                  color="#DB4437"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-trash-2"
                  size="small"
                  title="Delete User"
                  @click.stop="confirmDelete(data[indextr].id)"
                ></vs-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vx-card>
  </div>
</template>

<script>
import { Validator } from "vee-validate";
import VueImageUpload from "vue-image-crop-upload";
Validator.extend("verify_password", {
  //getMessage: field => `The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character (E.g. , . _ & ? etc)`,
  validate: value => {
    var strongRegex = new RegExp(
      "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})"
    );
    return strongRegex.test(value);
  }
});

//Validator.updateDictionary(dictionary);

const dict = {
  custom: {
    first_name: {
      required: "Please enter first name",
      alpha_spaces: "Only alphabetic characters and space allowed",
      max: "First name not be greater than 30 characters"
    },
    last_name: {
      required: "Please enter last name",
      alpha_spaces: "Only alphabetic characters and space allowed",
      max: "Last name not be greater than 30 characters"
    },
    email: {
      required: "Please enter email",
      email: "Please enter valid email"
    },
    password: {
      required: "Please enter password",
      min: "Password should be minimum 8 characters",
      verify_password:
        "Password should be minimum 8 characters : 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character (E.g. , . _ & ? etc)"
    },
    password_confirmation: {
      required: "Confirm password is required",
      confirmed: "Password and confirm password should be same"
    },
    role: {
      required: "Please select user role"
    }
  }
};
// register custom messages
Validator.localize("en", dict);

export default {
  components: {
    "vue-image-upload": VueImageUpload
  },
  data() {
    return {
      users: [],
      deleteIndex: 0,
      userAddEdit: false,
      firstName: null,
      lastName: null,
      email: null,
      password: null,
      confirm_password: null,
      userIndex: null,
      roleIndex: "SA",
      role_list: [
        {
          text: "Super Admin",
          value: "SA"
        }
        // {
        //   text: 'Company Admin',
        //   value: 'CA'
        // },
        // {
        //   text: 'HR Manager',
        //   value: 'HR'
        // },
        // {
        //   text: 'User',
        //   value: 'U'
        // },
      ],
      profile_image: null,

      show_image_popup: false,
      profile_image_update: false
    };
  },
  created() {
    if (this.$store.state.uInfo.role !== "SA") {
      history.back();
    }
    //   VeeValidate.Validator.extend('verify_password', {
    //   //getMessage: field => `The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character (E.g. , . _ & ? etc)`,
    //   validate: value => {
    //       var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
    //       return strongRegex.test(value);
    //   }
    //  });
  },
  mounted() {
    this.getusers();
  },
  computed: {
    email_validate() {
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(this.email);
    }
  },
  methods: {
    removeProfile() {
      this.profile_image = "";
      this.profile_image_update = false;
      if (this.userIndex) {
        this.profile_image_update = true;
      }
    },
    cropSuccess(imgDataUrl, field) {
      if (this.userIndex) {
        this.profile_image_update = true;
      }
      this.profile_image = imgDataUrl;
      this.profile_image_update = true;
      // if(this.$route.params.id) {
      //     this.imageUpdate = true
      // }
    },
    getusers() {
      this.$vs.loading({ color: "primary" });

      let url = "user/getUsers?type=SA";
      this.axios
        .get(url)
        .then(response => {
          this.$vs.loading.close();
          let data = response.data.data;
          this.users = data;
        })
        .catch(e => {
          this.showError(e);
        });
    },
    confirmDelete(index) {
      this.deleteIndex = index;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure you want to delete this User?",
        acceptText: "Delete",
        accept: this.deleteUser
      });
    },
    deleteUser() {
      let input = {
        data: {
          id: this.deleteIndex
        }
      };
      this.$vs.loading({ color: "primary" });
      this.axios
        .delete("user/deleteUser", input)
        .then(response => {
          this.$vs.loading.close();
          let text = "User deleted successfully!!!";
          this.$vs.notify({
            text: text,
            color: "success",
            position: "top-right"
          });
          this.deleteIndex = 0;
          this.getusers();
        })
        .catch(e => {
          this.deleteIndex = 0;
          this.showError(e);
        });
    },
    editUser(user) {
      this.userAddEdit = true;
      this.userIndex = user.id;
      this.firstName = user.firstname;
      this.lastName = user.lastname;
      this.email = user.email;
      this.password = "######";
      this.roleIndex = user.roles;
      this.profile_image = user.profile_image;
      this.profile_image_update = false;
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    addUpdateUser() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.button_loader(true, "#user-addupdate");

          if (this.userIndex) {
            this.updateUser();
          } else {
            this.addUser();
          }
        }
      });
    },
    addUser() {
      let input = {
        firstname: this.firstName,
        lastname: this.lastName,
        email: this.email,
        password: this.password,
        confirmpassword: this.confirm_password,
        type: this.roleIndex,
        profile_image: this.profile_image,
        profile_image_update: this.profile_image_update
      };
      this.axios
        .post("user/createUser", input)
        .then(response => {
          this.button_loader(false, "#user-addupdate");
          let text = "User created successfully!!!";
          this.$vs.notify({
            text: text,
            color: "success",
            position: "top-right"
          });
          this.userAddEdit = false;
          this.userIndex = null;
          this.firstName = null;
          this.lastName = null;
          this.email = null;
          this.password = null;
          this.userIndex = null;
          this.profile_image = null;
          this.profile_image_update = false;
          this.getusers();
        })
        .catch(e => {
          this.showError(e, "#user-addupdate");
        });
    },
    updateUser() {
      let input = {
        id: this.userIndex,
        firstname: this.firstName,
        lastname: this.lastName,
        email: this.email,
        type: this.roleIndex,
        profile_image: this.profile_image,
        profile_image_update: this.profile_image_update
      };
      this.axios
        .put("user/editUser", input)
        .then(response => {
          this.button_loader(false, "#country-addupdate");
          let text = "User updated successfully!!!";
          this.$vs.notify({
            text: text,
            color: "success",
            position: "top-right"
          });
          this.userAddEdit = false;
          this.userIndex = null;
          this.firstName = null;
          this.lastName = null;
          this.email = null;
          this.password = null;
          this.profile_image = null;
          this.profile_image_update = false;
          this.getusers();
        })
        .catch(e => {
          this.showError(e, "#country-addupdate");
        });
    },
    cancelAddEdit() {
      this.userAddEdit = false;
      this.userIndex = null;
      this.firstName = null;
      this.lastName = null;
      this.email = null;
      this.password = null;
      this.confirm_password = null;
      this.profile_image = null;
      this.profile_image_update = false;
    }
  }
};
</script>
		